import { Avatar, Box, Divider, Button, Container, Grid, MenuItem, Popover, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, AppBar, Toolbar, Checkbox, Typography, TableContainer, Paper } from '@mui/material'
import axios from 'axios';
import { Form, FormikProvider, useFormik } from 'formik';
import React, { Fragment, useState } from 'react'
import * as yup from 'yup';
import { format } from 'date-fns';
import { useSnackbar } from 'notistack';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import ExcelExport from './ExcelExport';
import _ from 'lodash';
import { TableVirtuoso } from 'react-virtuoso';
const baseURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_API_URL : process.env.REACT_APP_PRD_API_URL;

// ----------------------------------------------------------------------
function fDateTo(date, f) {
    return format(new Date(date), f);
}

function fDateZTo(date, f) {

    const utcDate = new Date(date);

    // ใช้ getUTC* เพื่อดึงเวลาจาก UTC
    const formattedDate =
        utcDate.getUTCFullYear() +
        "-" +
        String(utcDate.getUTCMonth() + 1).padStart(2, "0") +
        "-" +
        String(utcDate.getUTCDate()).padStart(2, "0") +
        " " +
        String(utcDate.getUTCHours()).padStart(2, "0") +
        ":" +
        String(utcDate.getUTCMinutes()).padStart(2, "0") +
        ":" +
        String(utcDate.getUTCSeconds()).padStart(2, "0");
    return format(formattedDate, f);
}

export default function Admin() {

    const { logout, authendata } = useAuth();
    const { contype, email, firstname, lastname } = authendata
    const navigate = useNavigate()

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const handleSnackWithAction = ({ message, onHandle }) => {
        enqueueSnackbar(message, {
            anchorOrigin: {
                horizontal: "center",
                vertical: 'bottom'
            },
            variant: 'default',
            action: (key) => (
                <Fragment>
                    <Button
                        size='small'
                        color="error"
                        onClick={() => {
                            closeSnackbar(key)
                            onHandle()
                        }}
                    >
                        ใช่
                    </Button>
                    <Button size='small' color="success" onClick={() => closeSnackbar(key)}>
                        ปิด
                    </Button>
                </Fragment>
            )
        });
    };




    const [anchorEl, setAnchorEl] = useState(null);

    const [rows, setRows] = useState([])
    const [rowsDownload, setRowsDownload] = useState([])

    const formSchema = yup.object().shape({
        datestart: yup.string().required('required'),
        dateend: yup.string().required('required')
    });
    const formik = useFormik({
        initialValues: {
            datestart: "",
            dateend: ""
        },
        validationSchema: formSchema,
        onSubmit: (values) => {
            const start = fDateTo(values.datestart, "yyyy-MM-dd")
            const end = fDateTo(values.dateend, "yyyy-MM-dd")
            axios.get(`${baseURL}/view/report/${start}/${end}/TLF`)
                .then((res) => {
                    setRows(res.data)
                    if (res.data.length === 0) {
                        handleSnackbar({ message: "Not found", variant: "error" })
                    }
                })
                .catch((error) => {
                    setRows([])
                    handleSnackbar({ message: "error", variant: "error" })
                })
        },
    });
    const handleSnackbar = ({ variant, message }) => {
        enqueueSnackbar(message, { variant, autoHideDuration: 1500, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } });
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);


    const onClickConfirm = ({ id, status }) => {
        const body = { id, status }
        axios.put(`${baseURL}/list/api/update`, body)
            .then((res) => {
                handleSnackbar({ message: "success!", variant: "success" })
                formik.submitForm()
            })
            .catch((error) => {
                handleSnackbar({ message: "error", variant: "error" })
            })
    }
    const onDelete = ({ id, filename }) => {
        const body = { id, filename }
        axios.delete(`${baseURL}/list/api/remove/files`, { data: body })
            .then((res) => {
                handleSnackbar({ message: "success!", variant: "success" })
                formik.submitForm()
            })
            .catch((error) => {
                handleSnackbar({ message: "error", variant: "error" })
            })
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setRowsDownload(rows);
        } else {
            setRowsDownload([]);
        }
    };
    const handleCheck = (row) => {
        const selected = isSelected(row.id);
        if (selected) {
            const newSelectedRows = rowsDownload.filter((rowDownload) => rowDownload.id !== row.id);
            setRowsDownload(newSelectedRows);
        } else {
            const newSelectedRows = rowsDownload.concat(row);
            setRowsDownload(newSelectedRows);
        }
    }
    const isSelected = (id) => {
        const rowSelected = rowsDownload.filter((v) => v.id === id)
        return rowSelected.length > 0
    }

    return (
        <Container maxWidth={false} sx={{ backgroundColor: "white" }}>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="sticky">
                    <Toolbar sx={{ marginLeft: 'auto' }}>
                        <Avatar sx={{ cursor: "pointer" }} onClick={handleClick} />
                    </Toolbar>
                </AppBar>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box sx={{ padding: "16px" }}>
                        <Typography variant="subtitle1">Name : {`${firstname} ${lastname}`}</Typography>
                        <Typography variant="subtitle1">Email : {email}</Typography>
                    </Box>
                    <Divider />
                    <MenuItem onClick={() => {
                        handleClose()
                        logout()
                        navigate('/login')
                    }}>Logout</MenuItem>
                </Popover>
            </Box>
            <Box padding={2}>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                color: "#906C4E"
                            }}
                        >
                            <Grid item xs={4} >
                                <TextField
                                    label="จากวันที่"
                                    {...formik.getFieldProps('datestart')}
                                    error={formik.touched.datestart && Boolean(formik.errors.datestart)}
                                    // helperText={formik.touched.datestart && formik.errors.datestart}
                                    name="datestart"
                                    type="date"
                                    value={formik.values.datestart}
                                    id="outlined-basic-1"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={4} >
                                <TextField
                                    label="ถึงวันที่"
                                    {...formik.getFieldProps('dateend')}
                                    error={formik.touched.dateend && Boolean(formik.errors.dateend)}
                                    // helperText={formik.touched.dateend && formik.errors.dateend}
                                    name="dateend"
                                    type="date"
                                    value={formik.values.dateend}
                                    id="outlined-basic-2"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={4} >
                                <Box>
                                    <Stack spacing={1} direction="row">
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            fullWidth
                                            sx={{ height: "100%" }}
                                        >
                                            ค้นหา
                                        </Button>
                                        {
                                            rows.length > 0 && (
                                                <ExcelExport disabled={rowsDownload.length === 0} data={
                                                    _.orderBy(rowsDownload, ["datebook", "timebook"], ["asc", "asc"]).map(v => {
                                                        return {
                                                            "วันที่จองเข้าร้าน": fDateTo(v.datebook, "dd/MM/yyyy"),
                                                            "เวลาที่เข้าร้าน": v.timebook,
                                                            "รหัสบัตรไกด์ไทย": v.thaiguidecode,
                                                            "จองในนาม": v.regcompany,
                                                            "ชื่อ-นามสกุลไกด์ไทย": v.thaifullname,
                                                            "ชื่อไกด์เวียดนาม/จีน": v.v_c_fullname,
                                                            "ชื่อบริษัททัวร์": v.tourcompany,
                                                            "กรุ๊ปโค๊ด": v.groupcode,
                                                            "สัญชาติลูกค้า": v.nationality,
                                                            "จำนวนผู้ใหญ่": v.adults,
                                                            "จำนวนหัวหน้าทัวร์": v.tourleaders,
                                                            "จำนวนลูกค้าเด็ก": v.child,
                                                            "ทะเบียนรถ": v.licenseplate,
                                                            "ประเภทรถ": v.vehicletype,
                                                            "ชื่อประเภทรถ": v.vehicletypename,
                                                            "เบอร์โทรศัพท์ติดต่อ": v.contactnumber,
                                                            "วันเวลาที่บันทึก": fDateZTo(v.created_at, "dd/MM/yyyy HH:mm:ss"),
                                                            "ไฟล์": v.file_id !== "" ? v.file_id.split(",").map((file, index) => {
                                                                return `${baseURL}/view/${file}`
                                                            }).join(",")
                                                                : ``,
                                                            "สถานะ": v.status === "confirm" ? "ยืนยัน" : "ไม่ยืนยัน"
                                                        }
                                                    })
                                                } fileName={`booking-download`} />
                                            )
                                        }
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                </FormikProvider>
                <Box sx={{ height: "calc(100vh - 135px)" }}>
                    <TableVirtuoso
                        data={_.orderBy(rows, ["datebook", "timebook"], ["asc", "asc"])}
                        components={VirtuosoTableComponents}
                        fixedHeaderContent={() => {
                            return (
                                <TableRow sx={{ backgroundColor: "white" }} >
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 20 }} padding="checkbox">
                                        <Checkbox
                                            indeterminate={rowsDownload.length > 0 && rowsDownload.length < rows.length}
                                            checked={rows.length > 0 && rowsDownload.length === rows.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 100 }}>วันที่จองเข้าร้าน</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 80 }}>เวลาที่เข้าร้าน</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 80 }}>รหัสบัตรไกด์ไทย</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 100 }}>จองในนาม</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 120 }}>ชื่อ-นามสกุลไกด์ไทย</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 100 }}>ชื่อไกด์เวียดนาม/จีน</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 120 }}>ชื่อบริษัททัวร์</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 200 }}>กรุ๊ปโค๊ด</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 100 }}>สัญชาติลูกค้า</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 80 }}>จำนวนผู้ใหญ่</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 80 }}>จำนวนหัวหน้าทัวร์</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 80 }}>จำนวนลูกค้าเด็ก</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 80 }}>ทะเบียนรถ</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 300 }}>ประเภทรถ</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 200 }}>ชื่อประเภทรถ</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 120 }}>เบอร์โทรศัพท์ติดต่อ</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 120 }}>วันเวลาที่บันทึก</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", width: 200 }}></TableCell>
                                </TableRow>
                            )
                        }
                        }
                        itemContent={(index, row) => {
                            return (
                                <React.Fragment key={`row-${index}`}>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }} padding="checkbox">
                                        <Checkbox
                                            checked={isSelected(row.id)}
                                            onChange={(event) => handleCheck(row)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{fDateTo(row.datebook, "dd/MM/yyyy")}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.timebook}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.thaiguidecode}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.regcompany}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.thaifullname}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.v_c_fullname}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.tourcompany}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.groupcode}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.nationality}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.adults}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.tourleaders}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.child}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.licenseplate}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.vehicletype}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.vehicletypename}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{row.contactnumber}</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap", backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>{fDateZTo(row.created_at, "dd/MM/yyyy HH:mm:ss")}</TableCell>
                                    <TableCell sx={{ backgroundColor: row.status !== "confirm" ? "white" : "whitesmoke" }}>
                                        <Box>
                                            <Stack direction="row" spacing={1} justifyContent="end">

                                                <Stack direction="column" spacing={1} justifyContent="left">
                                                    {row.file_id !== "" ? row.file_id !== "deleted" ?
                                                        row.file_id.split(",").map((file, index) => {
                                                            return (
                                                                <Button key={`file_id-${index + 1}`} href={`${baseURL}/view/${file}`} target="_blank" variant="outlined" size="small" >ดูไฟล์</Button>
                                                            )
                                                        })

                                                        : "ลบไฟล์แล้ว" : ""}
                                                </Stack>

                                                {row.status !== "confirm" ? <Button variant="contained" color="success" onClick={() => { onClickConfirm({ id: row.id, status: "confirm" }) }} size="small">ยืนยัน</Button> : <Button variant="outlined" color="error" onClick={() => { handleSnackWithAction({ message: "ต้องการยกเลิก?", onHandle: () => onClickConfirm({ id: row.id, status: "" }) }) }} size="small">ยกเลิก</Button>}
                                                {(contype === "00" || contype === "20") && (<Button variant='contained' color="error" onClick={() => { handleSnackWithAction({ message: "ต้องการลบรายการ?", onHandle: () => onDelete({ id: row.id, filename: row.file_id }) }) }} size="small">ลบ</Button>)}
                                            </Stack>
                                        </Box>
                                    </TableCell>
                                </React.Fragment>
                            )
                        }}
                    />
                </Box>
            </Box >
        </Container >
    )
}


const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
        <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
        <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
    ),
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableRow,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};